import { render, staticRenderFns } from "./ClaimNotFound.vue?vue&type=template&id=78e92356&"
import script from "./ClaimNotFound.vue?vue&type=script&lang=ts&"
export * from "./ClaimNotFound.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports